"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer as ChakraDrawer, DrawerOverlay, DrawerHeader, DrawerContent, useMultiStyleConfig, useBreakpointValue, } from "@chakra-ui/react";
import { Icons } from "../../../assets";
import { ButtonVariant, IconButton, SvgSpriteConsumer } from "../../atoms";
const Drawer = (_a) => {
    var _b;
    var { children, placement = "right", isOpen, onClose, title, icon, enableScroll = false, headerComponent } = _a, rest = __rest(_a, ["children", "placement", "isOpen", "onClose", "title", "icon", "enableScroll", "headerComponent"]);
    const display = useBreakpointValue({
        sm: "mobile",
        md: "tablet",
        lg: "desktop",
    }, {
        fallback: "sm",
    });
    const { color: colorTitle } = title || {};
    const styles = useMultiStyleConfig("Drawer", {
        display,
        colorTitle,
    });
    return (_jsxs(ChakraDrawer, Object.assign({ onClose: onClose, isOpen: isOpen, size: "full", placement: placement }, rest, { children: [_jsx(DrawerOverlay, {}), _jsxs(DrawerContent, Object.assign({ overflow: enableScroll ? "auto" : "unset" }, { children: [_jsx(IconButton, { sx: styles.button, "aria-label": "Close", variant: ButtonVariant.ICON, icon: _jsx(SvgSpriteConsumer, { svgId: Icons.DELETE24, size: 24 }), onClick: onClose }), _jsxs(DrawerHeader, { children: [headerComponent, !headerComponent && icon && (_jsx(SvgSpriteConsumer, { svgId: icon.svgId, size: 24, color: (_b = icon === null || icon === void 0 ? void 0 : icon.color) !== null && _b !== void 0 ? _b : "semantic.text.primary" })), title && (title.component || title.text)] }), children] }))] })));
};
Drawer.displayName = "Drawer";
export default Drawer;
//# sourceMappingURL=Drawer.js.map